import { Observable } from 'rxjs';
import { PendingInvoicesApiResponse } from '../../interfaces/pending-invoices/pending-invoices.interface';

export abstract class PendingInvoicesRepository {
  abstract getInvoices(userId: string): Observable<PendingInvoicesApiResponse>;
}
